'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

require('antd/lib/icon/style');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _icons = require('../config/data/icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __makeTemplateObject = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    } else {
        cooked.raw = raw;
    }
    return cooked;
};
var __assign = undefined && undefined.__assign || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Svg = _styledComponents2.default.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 1em;\n  height: 1em;\n  fill: currentColor;\n"], ["\n  width: 1em;\n  height: 1em;\n  fill: currentColor;\n"])));
var Icon = function Icon(_a) {
    var type = _a.type,
        className = _a.className,
        viewBox = _a.viewBox,
        color = _a.color;
    var icon = _icons.icons.find(function (iconConfig) {
        return iconConfig.type === type;
    });
    if (!icon) {
        return null;
    }
    if (icon.path) {
        var props = __assign({}, icon.props);
        if (color) {
            props.fill = color;
        }
        return _react2.default.createElement(Svg, { className: className, viewBox: viewBox || '0 0 24 24' }, _react2.default.createElement("path", __assign({ d: icon.path }, props)));
    }
    if (icon.antd) {
        return _react2.default.createElement(_icon2.default, { type: icon.antd, style: { verticalAlign: 'middle' } });
    }
    return null;
};
exports.default = Icon;

var templateObject_1;
//# sourceMappingURL=Icon.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/Icon/Icon.js
// module id = 2478
// module chunks = 0